<template lang="pug">
.kr-icon-arrow(v-html="caret" aria-hidden="true" :class="dynamicClasses")
</template>

<script>
import { mapState } from 'vuex'
import PreloadedAssets from '@/configuration/PreloadedAssets'

export default {
  name: 'CardBrandArrow',
  props: {
    activated: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      fieldIcons: state => state.fields.icons
    }),
    caret() {
      return (
        this.fieldIcons.miscellaneous.caret ||
        PreloadedAssets.miscellaneous.caret
      )
    },
    dynamicClasses() {
      return {
        'kr-icon-arrow-turned': this.activated
      }
    }
  }
}
</script>
